// src/shared/stores/ui-layer.store.ts
import React from 'react';
import { create } from 'zustand';

import { UILayerState, LayerType } from './useUILayerStore.type';

export const useUILayerStore = create<UILayerState>((set, get) => ({
	layers: [],
	getNextId: () => Math.max(...get().layers.map((layer) => layer.id), 0) + 1,
	pushLayer: (type: LayerType, UI: React.ReactElement) => {
		const layerId = get().getNextId();

		set((state) => ({
			layers: [...state.layers, { id: layerId, type, UI: () => UI }],
		}));

		return layerId;
	},
	popLayer: () => {
		set((state) => ({
			layers: state.layers.slice(0, -1),
		}));
	},
	popLayerFrom: (id: number) => {
		const targetIndex = get().layers.findIndex((layer) => layer.id === id);
		if (targetIndex === -1) return;

		set((state) => ({
			layers: state.layers.slice(0, targetIndex),
		}));
	},
	clearLayers: () => {
		set({ layers: [] });
	},
}));
